// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const ar = {
  demo: {
    title: `Arabic`,
    introduction: `لوريم إيبسوم هو ببساطة نص شكلي يستخدم في صناعة الطباعة والتنضيد. كان Lorem Ipsum هو النص الوهمي القياسي في الصناعة منذ القرن الخامس عشر الميلادي ، عندما أخذت طابعة غير معروفة لوحًا من النوع وتدافعت عليه لعمل كتاب عينة. لقد نجت ليس فقط خمسة قرون ، ولكن أيضًا القفزة في التنضيد الإلكتروني ، وظلت دون تغيير جوهري. تم نشره في الستينيات من القرن الماضي بإصدار أوراق Letraset التي تحتوي على مقاطع Lorem Ipsum ، ومؤخرًا مع برامج النشر المكتبي مثل Aldus PageMaker بما في ذلك إصدارات Lorem Ipsum.`,
  },
  docs: {
    hi: `أهلا`,
    description: `تحتاج مساعدة؟ \n الرجاء مراجعة مستنداتنا`,
    documentation: `توثيق`,
  },
  app: `تطبيق`,
  user: `المستعمل`,
  list: `قائمة`,
  edit: `تعديل`,
  shop: `متجر`,
  blog: `مقالات`,
  post: `بريد`,
  mail: `بريد`,
  chat: `دردشة`,
  cards: `البطاقات`,
  posts: `المشاركات`,
  create: `يزيد`,
  kanban: `كانبان`,
  general: `جنرال لواء`,
  banking: `الخدمات المصرفية`,
  booking: `الحجز`,
  profile: `الملف الشخصي`,
  account: `الحساب`,
  product: `المنتوج`,
  invoice: `فاتورة`,
  details: `تفاصيل`,
  checkout: `الدفع`,
  calendar: `التقويم`,
  analytics: `التحليلات`,
  ecommerce: `التجارة الإلكترونية`,
  management: `إدارة`,
  menu_level: `مستوى القائمة `,
  menu_level_2a: `مستوى القائمة 2 أ`,
  menu_level_2b: `مستوى القائمة 2 ب`,
  menu_level_3a: `مستوى القائمة 3 أ`,
  menu_level_3b: `مستوى القائمة 3 ب`,
  menu_level_4a: `مستوى القائمة 4 أ`,
  menu_level_4b: `مستوى القائمة 4 ب`,
  item_disabled: `العنصر معطل`,
  item_label: `تسمية العنصر`,
  item_caption: `عنوان العنصر`,
  item_external_link: `رابط خارجي للمادة`,
  description: `وصف`,
  other_cases: `حالات اخرى`,
  item_by_roles: `عنصر حسب الأدوار`,
  only_admin_can_see_this_item: `يمكن للمسؤول فقط رؤية هذا العنصر`,
  Title: `عنوان`,
  "No Data": `لايوجد بيانات`,
  Home: `بيت`,
  Dashboard: 'لوحة القيادة',
  Book: 'كتاب',
  User: 'مستخدم',
  Management: 'إدارة',
  Contacts: 'جهات الاتصال',
  Product: 'منتج',
  Theme: 'سمة',
  'Account Settings': 'إعدادت الحساب',
  'Area Installed': 'المنطقة المثبتة',
  'Current Download': 'التنزيل الحالي',
  'Balance Statistics': 'إحصائيات الرصيد',
  Add: 'يضيف',
  Edit: 'يحرر',
  'New Book': 'كتاب جديد',
  Cancel: 'يلغي',
  'Create Book': 'إنشاء كتاب',
  Name: 'اسم',
  Description: 'وصف',
  Price: 'سعر',
  'Book Details': 'تفاصيل الكتاب',
  Details: 'تفاصيل',
  'Save Changes': 'حفظ التغييرات',
  'Drop or Select file': 'قم بإسقاط أو تحديد الملف',
  'Drop files here or click': 'قم بإسقاط الملفات هنا أو انقر فوق',
  'browse': 'تصفح',
  'thorough your machine': 'شامل جهازك',
  Images: 'الصور',
  Dense: 'كثيف',
  Books: 'كتب',
  Status: 'حالة',
  'Created At': 'أنشئت في',
  selected: 'المحدد',
  Delete: 'يمسح',
  Approve: 'يعتمد',
  Pending: 'قيد الانتظار',
  Asia: 'آسيا', //new
  America: 'أمريكا', //new
  Total: 'المجموع', //new
  Income: 'دخل', //new
  Expense: 'مصروف', //new
  'than last year': 'من العام الماضي', //new
  'New User': 'مستخدم جديد',
  'First Name': 'الاسم الأول',
  'Last Name': 'اسم العائلة',
  Email: 'بريد إلكتروني',
  Approved: 'موافقة',
  Gender: 'جنس',
  Country: 'دولة',
  State: 'ولاية',
  City: 'مدينة',
  'User List': 'قائمة المستخدم',
  Role: 'دور',
  'State/Region': 'الولاية/المنطقة',
  'Phone Number': 'رقم التليفون',
  Address: 'عنوان',
  Company: 'شركة',
  'Zip/Code': 'الرمز البريدي',
  Allowed: 'مسموح', //new
  'max size of': 'الحد الأقصى لحجم', //new
  'Update photo': 'تحديث الصورة', //new
  'Upload photo': 'حمل الصورة', //new
  'Detail user': 'مستخدم التفاصيل',
  'Approve this User?': 'هل توافق على هذا المستخدم؟',
  "Enabling this will now allow user to login.": 'سيؤدي تمكين هذا الآن إلى السماح للمستخدم بتسجيل الدخول.',
  "Activate this account?": 'تفعيل هذا الحساب؟',
  "Disabling this will deactivate users account.": 'سيؤدي تعطيل هذا إلى إلغاء تنشيط حساب المستخدمين.',
  'Edit user': 'تحرير العضو',
  Settings: 'إعدادات',
  Mode: 'وضع',
  Contrast: 'مقابلة',
  Direction: 'اتجاه',
  Layout: 'تَخطِيط',
  Stretch: 'تمتد',
  Presets: 'الإعدادات المسبقة',
  Fullscreen: 'تكبير الشاشة', //new
  'Exit Fullscreen': 'الخروج من الشاشة الكاملة', //new
  'Only available at large resolutions > 1600px (xl)': 'متوفر فقط بدقة كبيرة> 1600 بكسل (XL)',
  'Create a new user': 'إنشاء مستخدم جديد',
  'Create User': 'إنشاء مستخدم',
  Profile: 'حساب تعريفي',
  Logout: 'تسجيل خروج',
  'Super Admin': 'المشرف الفائق',
  'Site Admin': 'مشرف الموقع',
  Admin: 'مسؤل',
  'Organization Admin': 'مدير المنظمة',
  'Individual User': 'مستخدم فردي',
  About: 'عن',
  'Change password': 'تغيير كلمة المرور',
  General: 'عام',
  'Old Password': 'كلمة المرور القديمة',
  'New Password': 'كلمة المرور الجديدة',
  'Confirm New Password': 'تأكيد كلمة المرور الجديدة',
  Notifications: 'إشعارات',
  'View All': 'عرض الكل',
  Notification: 'إشعار',
  Date: 'تاريخ',
  Time: 'وقت',
  'Please Select Gender': 'يرجى تحديد الجنس',
  'Please Select a country': 'رجاء قم بإختيار دوله',
  'Please Select a role': 'الرجاء تحديد الدور',
  Yes: 'نعم',
  No: 'لا',
  Male: 'ذكر',
  Female: 'أنثى',
  Others: 'آحرون',
  More: 'أكثر',
  Transactions: 'المعاملات',
  transactions: 'المعاملات',
  Organization: 'منظمة',
  Plans: 'الخطط',
  Model: 'نموذج',
  'Audit Trials': 'محاكمات التدقيق',
  'Logs': 'السجلات',
  'File Upload': 'تحميل الملف',
  'Invoices': 'الفواتير',
  'Subscriptions': 'الاشتراكات',
  'My Subscriptions': 'اشتراكاتي',
  'View API Keys': 'عرض مفاتيح API',
  'View Encryption Keys': "عرض مفاتيح التشفير",
  'All': 'الجميع',
  'Unread': 'غير مقروءة',
  'Read': 'يقرأ',
  'Mark all as read': 'اشر عليها بانها قرات',
  'communication': 'تواصل',
  'Api Keys': 'مفاتيح واجهة برمجة التطبيقات',
  'Your secret API keys are listed below.': 'مفاتيح API السرية الخاصة بك مدرجة أدناه.',
  'Please note that we do not display your secret API keys again after you generate them.': 'يرجى ملاحظة أننا لا نعرض مفاتيح API السرية الخاصة بك مرة أخرى بعد إنشائها.',
  'Do not share your API key with others, or expose it in the browser or other client-side code. In order to protect the security of your account,': 'لا تشارك مفتاح API الخاص بك مع الآخرين، أو تعرضه في المتصفح أو أي رمز آخر من جانب العميل. من أجل حماية أمان حسابك،',
  "may also automatically rotate any API key that we've found has leaked publicly.": 'قد تقوم أيضًا بتدوير أي مفتاح API وجدنا أنه قد تم تسريبه بشكل عام تلقائيًا.',
  'Key': "مفتاح",
  "Created": "مخلوق",
  "Last Used": "آخر أستخدام",
  "Generate New Secret Key": "إنشاء مفتاح سري جديد",
  "Please save this secret key somewhere safe and accessible. For security reasons,": 'يرجى حفظ هذا المفتاح السري في مكان آمن ويمكن الوصول إليه. لأسباب أمنية،',
  "you won't be able to view it again": "لن تتمكن من مشاهدته مرة أخرى",
  "through your IDP account. If you lose this secret key, you'll need to generate a new one.": "من خلال حساب آي دي بي الخاص بك. إذا فقدت هذا المفتاح السري، فستحتاج إلى إنشاء مفتاح جديد.",
  "Done": "منتهي",
  "Optional": "خياري",
  "Create Secret Key": "إنشاء مفتاح سري",
  "API Name": "اسم واجهة برمجة التطبيقات",
  "Create new secret key": "إنشاء مفتاح سري جديد",
  "Are you sure want to delete": "هل أنت متأكد أنك تريد الحذف",
  "items?": "أغراض؟",
  "Copy": "ينسخ",
  "Copied": "نسخ",
  "Revoke": "سحب او إبطال",
  "Revoke secret key": "إبطال المفتاح السري",
  "This API key will immediately be disabled. API requests made using this key will be rejected, which could cause any systems still depending on it to break. Once revoked, you'll no longer be able to view or modify this API key.": "سيتم تعطيل مفتاح API هذا على الفور. سيتم رفض طلبات واجهة برمجة التطبيقات (API) التي تم إجراؤها باستخدام هذا المفتاح، مما قد يؤدي إلى تعطل أي أنظمة لا تزال تعتمد عليه. بمجرد إبطاله، لن تتمكن بعد الآن من عرض أو تعديل مفتاح واجهة برمجة التطبيقات (API) هذا.",
  "Label": "ملصق",
  "Value": "قيمة",
  "Encryption Keys": "مفاتيح التشفير",
  "Encryption Key": "مفتاح التشفير",
  "Generate New Encryption Key": "إنشاء مفتاح تشفير جديد",
  "Change Encryption Key": "تغيير مفتاح التشفير",
  "Create new Encryption Key": "إنشاء مفتاح تشفير جديد",
  "Create Encryption Key": "إنشاء مفتاح التشفير",
  "Encryption Key Value": "قيمة مفتاح التشفير",
  "First Name is required": "الإسم الأول مطلوب",
  "Update success!": "نجاح التحديث!",
  "Verification Email Sent. Check your email": "تم إرسال البريد الإلكتروني للتحقق. تحقق من بريدك الالكتروني",
  "Verification OTP Sent. Check your Messages": "تم إرسال التحقق لمرة واحدة (OTP). تفقد رسائلك",
  "Save": "يحفظ",
  "Your Email not verified yet": "لم يتم التحقق من بريدك الإلكتروني بعد",
  "Verify": "يؤكد",
  "Please select country code": "الرجاء تحديد رمز البلد",
  "Your Phone number not verified": "لم يتم التحقق من رقم هاتفك",
  "Allowed *.jpeg, *.jpg, *.png, *.gif": "مسموح به *.jpeg، *.jpg، *.png، *.gif",
  "Verify Your Mobile Number": "تحقق من رقم هاتفك المحمول",
  "Please check your Messages!": "يرجى التحقق من رسائلك!",
  "box to login to your account": "المربع لتسجيل الدخول إلى حسابك",
  "We have messaged a 6-digit confirmation code, please enter the code in below": "لقد قمنا بإرسال رمز التأكيد المكون من 6 أرقام، يرجى إدخال الرمز أدناه",
  "Verify Code": "التحقق من كود",
  "We have messaged a 6-digit confirmation code to": "لقد أرسلنا رمز التأكيد المكون من 6 أرقام إلى",
  ", please enter the code in below box to login to your account": "، يرجى إدخال الرمز في المربع أدناه لتسجيل الدخول إلى حسابك",
  "Return to sign in": "العودة لتسجيل الدخول",
  "Code is required": "الكود مطلوب",
  "Verify success!": "التحقق من النجاح!",
  "Old Password is required": "كلمة المرور القديمة مطلوبة",
  "New Password is required": "كلمة المرور الجديدة مطلوبة",
  "Passwords must match": "يجب أن تتطابق كلمات المرور",
  "New password must be different than old password": "كلمة المرور الجديدة يجب أن تكون مختلفة عن كلمة المرور القديمة",
  "Password must be at least 6 characters": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
  "Threshold": "عتبة",
  "Org Code": "رمز المنظمة",
  "Pan Number": "رقم عموم",
  "GST IN": "رقم ضريبة القيمة المضافة",
  "Model Name": "اسم النموذج",
  "File Types": "أنواع الملفات",
  "Feature Name": "اسم الميزة",
  "Plan Name": "اسم الخطة",
  "Model :: Feature": "الموديل:: الميزة",
  "Subscribed On": "تم الاشتراك فيه",
  "Organization Name": "اسم المنظمة",
  "Password": "كلمة المرور",
  "Organization Code": "رمز المنظمة",
  "Admin First Name": "الاسم الأول للمسؤول",
  "Admin Last Name": "الاسم الأخير للمسؤول",
  "File": "ملف",
  "Unable to logout!": "غير قادر على تسجيل الخروج!",
  "Audit Logs": "سجلات التدقيق",
  "Timestamp": "الطابع الزمني",
  "No audit logs found": "لم يتم العثور على سجلات التدقيق",
  "Enter Your Password": "ادخل رقمك السري",
  "Enter a new password for": "أدخل كلمة مرور جديدة ل",
  "Email is required": "البريد الالكتروني مطلوب",
  "Email must be a valid email address": "يجب أن يكون البريد الإلكتروني عنوان بريد إلكتروني صالحًا",
  "Password is required": "كلمة المرور مطلوبة",
  "Confirm password is required": "تأكيد كلمة المرور مطلوب",
  "Change password success!": "تغيير كلمة المرور بنجاح!",
  "Update Password": "تطوير كلمة السر",
  "Email address": "عنوان البريد الإلكتروني",
  "Send Request": "ارسل طلب",
  "Phone number is required": "رقم الهاتف مطلوب",
  "Send Otp": "إرسال مكتب المدعي العام",
  "Code must be at least 6 characters": "يجب أن يتكون الرمز من 6 أحرف على الأقل",
  "Reset Password": "إعادة تعيين كلمة المرور",
  "Forgot your password?": "Forgot your password?",
  "Please enter the email address associated with your account and We will email you a link to reset your password.": "يرجى إدخال عنوان البريد الإلكتروني المرتبط بحسابك وسنرسل إليك رابطًا عبر البريد الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك.",
  "We've sent you an email with a link to finish resetting your password.": "لقد أرسلنا إليك بريدًا إلكترونيًا يتضمن رابطًا لإنهاء إعادة تعيين كلمة المرور الخاصة بك.",
  "Can't find the email? Try checking your spam folder.": "لا يمكن العثور على البريد الإلكتروني؟ حاول التحقق من مجلد الرسائل غير المرغوب فيها.",
  "Login": "تسجيل الدخول",
  "Login With Otp": "تسجيل الدخول باستخدام Otp",
  "Please enter the phone number (with country code) associated with your account and We will sent you a 6 digit code.": "يرجى إدخال رقم الهاتف (مع رمز البلد) المرتبط بحسابك وسنرسل لك رمزًا مكونًا من 6 أرقام.",
  "We've sent you an message with a 6 digit code.": "لقد أرسلنا لك رسالة تحتوي على رمز مكون من 6 أرقام.",
  "Sign Up": "اشتراك",
  "Card": "بطاقة",
  "Add new card": "إضافة بطاقة جديدة",
  "Card Information Submited": "تم إرسال معلومات البطاقة",
  "Error in saving card details": "خطأ في حفظ تفاصيل البطاقة",
  "Card Number": "رقم البطاقة",
  "Card Holder": "حامل البطاقة",
  "JOHN DOE": "فلان الفلاني",
  "Expiration Date": "تاريخ انتهاء الصلاحية",
  "CVV/CVC": "CVV/CVC",
  "Your transaction is secured with SSL encryption": "معاملتك مؤمنة بتشفير SSL",
  "Save as default": "إحفظ كافتراضي",
  "Three-digit number on the back of your card": "رقم مكون من ثلاثة أرقام على ظهر بطاقتك",
  "New Card": "بطاقة جديدة",
  "Credit / Debit Card": "بطاقة الائتمان / الخصم",
  "Event Body is required": "نص الحدث مطلوب",
  "Email Subject is required": "موضوع البريد الإلكتروني مطلوب",
  "Event Body": "هيئة الحدث",
  "Users": "المستخدمين",
  "Send": "يرسل",
  "than last month": "من الشهر الماضي",
  "Please fill your billing details!": "",
  "Fill Now": "املأ الآن",
  "Give Consent": "إعطاء الموافقة",
  "Please provide your data storage consent!": "يرجى تقديم موافقتك على تخزين البيانات!",
  "Total Transactions": "إجمالي المعاملات",
  "Total Users": "إجمالي المستخدمين",
  "Total Subscriptions": "إجمالي الاشتراكات",
  "Transaction Values": "قيم المعاملات",
  "Transactions Details": "تفاصيل المعاملات",
  "Failed": "فشل",
  "Complete": "مكتمل",
  "Forbidden": "ممنوع",
  "No permission": "لا يوجد إذن",
  "The page you": "الصفحة لكم",
  "re trying access has restricted access.": "إعادة محاولة الوصول مقيدة الوصول.",
  "Please refer to your system administrator": "يرجى الرجوع إلى مسؤول النظام الخاص بك",
  "Go to Home": "اذهب إلى الصفحة الرئيسية",
  "Page Not Found": "الصفحة غير موجودة",
  "Sorry, page not found!": "عذرا، لم يتم العثور على الصفحة!",
  "Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be": "عذرًا، لم نتمكن من العثور على الصفحة التي تبحث عنها. ربما أخطأت في كتابة عنوان URL؟ يكون",
  "sure to check your spelling.": "تأكد من التدقيق الإملائي.",
  "Internal Server Error": "خطأ في الخادم الداخلي",
  "There was an error, please try again later.": "كان هناك خطأ، الرجاء المحاولة مجددا لاحقا.",
  "File is required": "الملف مطلوب",
  "Error in Processing": "خطأ في المعالجة",
  "Error in Data Processing": "خطأ في معالجة البيانات",
  "Invalid Data Provided": "تم تقديم بيانات غير صالحة",
  "Upload": "رفع",
  "Plan List": "قائمة الخطة",
  "Select a Plan": "حدد خطة",
  "View Json": "عرض جيسون",
  "Processed Json": "معالجة جيسون",
  "Transaction Detail": "تفاصيل الصفقة",
  "Invoice from": "الفاتورة من",
  "Intelligent Document Processing (iDP)": "المعالجة الذكية للمستندات (iDP)",
  "Invoice to": "فاتورة إلى",
  "Phone": "هاتف",
  "Date create": "تاريخ الإنشاء",
  "Qty": "الكمية",
  "Unit price": "سعر الوحدة",
  "NOTES": "ملحوظات",
  "We appreciate your business. Should you need us to add VAT or extra notes let us know!": "نحن نقدر عملك. إذا كنت بحاجة إلينا لإضافة ضريبة القيمة المضافة أو ملاحظات إضافية، فأخبرنا بذلك!",
  "Have a Question?": "لدي سؤال؟",
  "Invoice Details": "تفاصيل الفاتورة",
  "View": "منظر",
  "Download": "تحميل",
  "Print": "مطبعة",
  "Send Forward": "إرسال إلى الأمام",
  "Share": "يشارك",
  "Mark as Paid": "وضع علامة على أنه مدفوع",
  "Close": "يغلق",
  "Invoice to is required": "مطلوب الفاتورة",
  "Due date must be later than create date": "يجب أن يكون تاريخ الاستحقاق بعد تاريخ الإنشاء",
  "Invoice Updated!": "تم تحديث الفاتورة!",
  "Invoice Created!": "تم إنشاء الفاتورة!",
  "Save as Draft": "حفظ كمسودة",
  "Update & Send": "تحديث وإرسال",
  "Create & Send'": "إنشاء وإرسال",
  "Select address": "حدد العنوان",
  "Add New": "اضف جديد",
  "From": "من",
  "To": "ل",
  "Change": "يتغير",
  "full stack development": "تطوير المكدس الكامل",
  "backend development": "تطوير الواجهة الخلفية",
  "ui design": "تصميم واجهة المستخدم",
  "ui/ux design": "تصميم واجهة المستخدم/UX",
  "front end development": "تطوير الواجهة الأمامية",
  "Service": "خدمة",
  "None": "لا أحد",
  "Quantity": "كمية",
  "Remove": "يزيل",
  "Add Item": "اضافة عنصر",
  "Discount": "تخفيض",
  "Taxes": "الضرائب",
  "Subtotal": "المجموع الفرعي",
  "Total price": "السعر الكلي",
  "paid": "مدفوع",
  "unpaid": "غير مدفوعة الأجر",
  "overdue": "تأخرت",
  "draft": "مسودة",
  "Invoice number": "رقم الفاتورة",
  "Due date": "تاريخ الاستحقاق",
  "New Invoice": "فاتورة جديدة",
  "Create a new invoice": "إنشاء فاتورة جديدة",
  "Invoice: View": "الفاتورة: عرض",
  "Pay Now": "ادفع الآن",
  "Edit invoice": "تحرير الفاتورة",
  "all": "الجميع",
  "Client": "عميل",
  "Create": "يخلق",
  "Amount": "خلق",
  "Invoice": "فاتورة",
  "Paid": "فاتورة",
  "Unpaid": "غير مدفوعة الأجر",
  "Invoice List": "قائمة الفاتورة",
  "Sent": "مرسل",
  "Models": "عارضات ازياء",
  "Models Detail": "تفاصيل النماذج",
  "Model List": "قائمة النماذج",
  "New": "جديد",
  "Edit Models": "تحرير النماذج",
  delete_confirmation: `هل أنت متأكد أنك تريد حذف العنصر {{value1}}؟`,
  "Search...": "يبحث...",
  "Clear": "واضح",
  "Create a new Model": "إنشاء نموذج جديد",
  "New Model": "نموذج جديد",
  "Model Name is required": "",
  "File Types is required": "",
  "Feature Name is required": "",
  "Price is required": "",
  "Create Success!": "تحقيق النجاح!",
  "Model Status": "حالة النموذج",
  "Disabling this will model will affect users.": "سيؤثر تعطيل هذا النموذج على المستخدمين.",
  "Is Private": "هو خاص",
  "Enabling this to only super admin shown the this model.": "يؤدي تمكين هذا للمشرف المتميز فقط إلى إظهار هذا النموذج.",
  "Organization Detail": "تفاصيل المنظمة",
  "Organization Users": "مستخدمو المنظمة",
  "Detail": "التفاصيل",
  "Edit Organization": "تحرير المنظمة",
  "Organizations": "المنظمات",
  "Organization List": "قائمة المنظمة",
  "New Organization": "منظمة جديدة",
  "Create a new organization": "إنشاء منظمة جديدة",
  "Org Name is required": "اسم المنظمة مطلوب",
  "GST Number is required": "رقم ضريبة السلع والخدمات مطلوب",
  "Pan Number is required": "رقم عموم مطلوب",
  "Payment Information Required?": "معلومات الدفع مطلوبة؟",
  "Enabling this will now ask user to submit their payment details.": "سيؤدي تمكين هذا الآن إلى مطالبة المستخدم بإرسال تفاصيل الدفع الخاصة به.",
  "Order Summary": "ملخص الطلب",
  "Invoice Number": "رقم الفاتورة",
  "Overdue": "تأخرت",
  "Payment Successful": "تم الدفع بنجاح",
  "Payment UnSuccessful": "الدفع غير ناجح",
  "Payment": "قسط",
  "Complete Order": "اكمل الطلب",
  "Pay $": `ادفع {{value1}} دولار`,
  "Organizaton Details": "تفاصيل المنظمة",
  "organizaton_name": "اسم المنظمة: {{value1}}",
  "Plans List": "قائمة الخطط",
  "Master Plan": "الخطة الرئيسية",
  "Deactivate": "إلغاء التنشيط",
  "Are you sure want to deactivate plan": "هل أنت متأكد أنك تريد إلغاء تنشيط الخطة",
  "All Plans": "جميع الخطط",
  "Subscribed Plans": "الخطط المشتركة",
  "New Plan": "خطة جديدة",
  "Loading": "تحميل",
  "Unsubscribe": "إلغاء الاشتراك",
  "Subscribe": "يشترك",
  "Edit Plan": "تحرير الخطة",
  "Plan": "يخطط",
  "Create a New Plan": "إنشاء خطة جديدة",
  "Create a Custom Plan": 'قم بإنشاء خطة لنفسك',
  "Plan Name is required": "اسم الخطة مطلوب",
  "Models are required": "النماذج مطلوبة",
  "No Changes": "لا تغيرات",
  "Organization Plan": "الخطة التنظيمية",
  "Enabling this to allow set orgaization for this plan": "تمكين هذا للسماح بالتنظيم المحدد لهذه الخطة",
  "All Organzation": "كل المنظمة",
  "Total Price": "السعر الكلي",
  "Upload From Gallery": "تحميل من المعرض",
  "Disagree": "تعارض",
  "Agree": "يوافق",
  "Want to open": "تريد فتح",
  "Subscriptions List": "قائمة الاشتراكات",
  "Remove Subscription": "إزالة الاشتراك",
  "Subscription Assigned Successfully": "تم تعيين الاشتراك بنجاح",
  "Please try again": "حاول مرة اخرى",
  "Subscription Removed Successfully": "تمت إزالة الاشتراك بنجاح",
  "all items selected": "كافة العناصر المحددة",
  "move selected right": "التحرك المحدد لليمين",
  "Assigned List": "القائمة المخصصة",
  "move selected left": "نقل المحدد إلى اليسار",
  "Organization Subscriptions List": "قائمة اشتراكات المنظمة",
  "Organization Subscriptions": "اشتراكات المنظمة",
  "Manage Users": "ادارة المستخدمين",
  "Assign Plan or Remove Plan": "تعيين الخطة أو إزالة الخطة",
  "selected_user": "تم تحديد {{value1}}",
  "Threshold Updated!": "تم تحديث العتبة!",
  "Role is required": "الدور مطلوب",
  "Start date": "تاريخ البدء",
  "End date": "تاريخ الانتهاء",
  "All Users": "جميع المستخدمين",
  "Select Role": "حدد الدور",
  "User Detail": "تفاصيل المستخدم",
  "Full Name": "الاسم الكامل",
  "File Detail": "تفاصيل الملف",
  "File Name": "اسم الملف",
  "Model Detail": "نموذج التفاصيل",
  "Total Processing Time": "إجمالي وقت المعالجة",
  "Start Time": "وقت البدء",
  "End Time": "وقت النهاية",
  "Processing Time": "وقت المعالجة",
  "Modification Detail": "تفاصيل التعديل",
  "Updated At": "تم التحديث في",
  "Transaction": "عملية",
  "Transaction List": "قائمة المعاملات",
  "Success": "نجاح",
};

export default ar;
